import MuiInputLabel, { InputLabelProps } from '@mui/material/InputLabel';
import { styled } from '@mui/system';

export const InputLabel = styled(MuiInputLabel)<InputLabelProps>(({ theme }) => ({}));
